import React, { createContext, useContext, ReactNode } from 'react';
import { UploadedFile } from '../../hooks/file-uploads/types';

type FileDragDropContextType = {
  draggedItem: UploadedFile | null;
  setDraggedItem: (item: UploadedFile | null) => void;
  isDraggedOver: string | null;
  setIsDraggedOver: (id: string | null) => void;
  handleMoveFile: (file: UploadedFile, parentId: string | null | undefined) => Promise<void>;
  allFiles: UploadedFile[];
  selectedIds?: ReadonlySet<string>;
  canDropOnTarget: (targetId: string | null) => boolean;
  isDragging: (itemId: string) => boolean;
  isDropTarget: (itemId: string) => boolean;
};

const FileDragDropContext = createContext<FileDragDropContextType | null>(null);

type Props = {
  children: ReactNode;
  contextValue: FileDragDropContextType;
};

export function FileDragDropProvider({ children, contextValue }: Props) {
  return <FileDragDropContext value={contextValue}>{children}</FileDragDropContext>;
}

export function useFileDragDrop() {
  return useContext(FileDragDropContext);
}
